// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"N7-z"};